export { default as RootPage } from './root/root.page';
export { default as HomePage } from './home/home.page';
export { default as UsersPage } from './users/users.page';
export { default as CategoriesPage } from './category/categories.page';
